import storage from 'store2';

export const SMS_TOKEN_LENGTH = 6;
export const TOKEN_EXPIRES_IN_DELAY = 60000;
export const AUTHORIZATION_EXPIRED_ERROR = 'AUTHORIZATION_EXPIRED';
export const UNHASHED_RTA_TOKEN = 'rtaToken';
export const CURRENTLY_LOGGED_USER_EMAIL = 'currentlyLoggedUserEmail';

export const authorizationStorage = storage.local.namespace('authorization');
